const S = {
  adminGrid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 },
  statCard: { background: "#161616", border: "1px solid #222", borderRadius: 12, padding: 20, textAlign: "center", display: "flex", flexDirection: "column", gap: 6, alignItems: "center" },
  adminPanel: { background: "#161616", border: "1px solid #222", borderRadius: 12, padding: 20 },
  panelTitle: { fontSize: 14, color: "#c9a96e", fontWeight: 700, marginBottom: 16, display: "block" },
  userRow: { display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #1a1a1a" },
  logRow: { padding: "8px 0", borderBottom: "1px solid #1a1a1a", display: "flex", flexDirection: "column", gap: 2 },
};

export default function AdminPanel({ users, sharedVault, personalVault, logs }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={S.adminGrid}>
        {[
          { label: "Usuarios activos", value: users.length, icon: "👥" },
          { label: "Credenciales compartidas", value: sharedVault.length, icon: "🔐" },
          { label: "Credenciales personales", value: Object.values(personalVault).flat().length, icon: "🔑" },
          { label: "Total en bóveda", value: sharedVault.length + Object.values(personalVault).flat().length, icon: "📊" },
        ].map(s => (
          <div key={s.label} style={S.statCard}>
            <div style={{ fontSize: 28 }}>{s.icon}</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: "#c9a96e" }}>{s.value}</div>
            <div style={{ fontSize: 12, color: "#aaa" }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <div style={S.adminPanel}>
          <h3 style={S.panelTitle}>Usuarios</h3>
          {users.map(u => (
            <div key={u.id} style={S.userRow}>
              <div style={{ width: 34, height: 34, borderRadius: "50%", background: u.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#111" }}>{u.avatar}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, color: "#eee" }}>{u.name}</div>
                <div style={{ fontSize: 11, color: "#888" }}>{u.email}</div>
              </div>
              <span style={{ padding: "3px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, background: u.role === "admin" ? "#c9a96e22" : "#7eb8c922", color: u.role === "admin" ? "#c9a96e" : "#7eb8c9" }}>
                {u.dept}
              </span>
            </div>
          ))}
        </div>
        <div style={S.adminPanel}>
          <h3 style={S.panelTitle}>Registro de actividad</h3>
          {logs.map((log, i) => (
            <div key={i} style={S.logRow}>
              <div style={{ fontSize: 12, color: "#c9a96e" }}>{log.user}</div>
              <div style={{ fontSize: 12, color: "#ccc" }}>{log.action}: <strong>{log.item}</strong></div>
              <div style={{ fontSize: 11, color: "#666" }}>{log.time}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
